import React, { useMemo } from 'react';

import get from 'lodash/get';

import Typography from 'components/Typography';
import { NETWORK_MOBILE, NETWORK_WEB } from 'scenes/FinancePage/IO/constants';

const Remarks = ({ data }: { data: any }) => {
  const network = get(data, 'businessPartner.details.networkId');

  const { isWeb, isMobile } = useMemo(
    () => ({
      isWeb: network === NETWORK_WEB,
      isMobile: network === NETWORK_MOBILE,
    }),
    [network]
  );

  return (
    <div className={'ion-padding'}>
      {isWeb ? (
        <>
          <Typography className={'ion-padding-bottom'} lineClamp={0}>
            Unused monthly budgets will not be transferred to the following
            month(s).
          </Typography>
          <Typography lineClamp={0}>
            Campaign criteria, including rates and fees, may be updated and
            agreed by email or any other electronical messaging system usually
            used between the parties to communicate. Unless otherwise agreed by
            email, the parties agree to $100/day daily cap. Any campaign update
            shall apply within 1 business day.
          </Typography>
        </>
      ) : null}

      {isMobile ? (
        <>
          <Typography className={'ion-padding-bottom'} lineClamp={0}>
            Conversion Rate (CVR) No. of installs generated from total amount of
            clicks, should be in the range of 0.5% to 15%.
          </Typography>
          <Typography className={'ion-padding-bottom'} lineClamp={0}>
            Campaign criteria, including rates and fees, may be updated and
            agreed by email or any other electronical messaging system usually
            used between the parties to communicate.
          </Typography>
          <Typography lineClamp={0}>
            Unused monthly budgets will not be transferred to the following
            month(s).
          </Typography>
        </>
      ) : null}
    </div>
  );
};

export default Remarks;
